import { connect } from "react-redux";
import React, { useEffect } from "react";

const Dashboard = (props) => {
  useEffect(() => {
    // const HospitalId = JSON.stringify({
    //   hid: localStorage.getItem("hospitalCode").toString(),
    // });
    // props.getAllOpdVisits(HospitalId);
  }, []); // Empty dependency array means this effect runs once on mount

  return (
    <div>
      <h1>Welcome to the Dashboard</h1>
    </div>
  );
};

const mapStateToProps = (state) => ({
  // allopdvisitsList: state.setuphospitleopdOutReducer.allopdvisitsList,
});

export default connect(mapStateToProps, {
  // getAllOpdVisits,
})(Dashboard);